import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const userToken = rootState['DATA-ACCESS'].userToken;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'user-token': userToken
    },
  };

  let path = `${URI_GUARD_REQUEST}serpro/get-vehicle-history-by-credit`;
  if (payload) {
    const query = Object.keys(payload)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
      .join('&');

    path += `?${query}`;
  }

  const response = await fetch(path, opts);

  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    return Promise.reject(jsonResult.message);
  }
  return jsonResult
};
